var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotificationsLike = function SvgNotificationsLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.05273,
    cy: 9.05273,
    r: 8.5,
    fill: "black",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67011 12.9892C5.37327 11.6677 4.25063 9.18082 4.62011 7.30504C4.8759 5.94082 5.91327 5.01714 7.19221 5.00293C7.83055 5.02112 8.45098 5.21793 8.98274 5.57135C9.51237 5.22632 10.1273 5.03433 10.7591 5.01714C12.0522 5.01714 13.0612 5.9124 13.3312 7.29082C13.6864 9.16661 12.5781 11.6392 9.29537 12.9892C9.19576 13.0279 9.0896 13.0472 8.98274 13.0461C8.87588 13.0472 8.76972 13.0279 8.67011 12.9892Z",
    fill: "#4353FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotificationsLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notifications-like.077f5e52.svg";
export { ForwardRef as ReactComponent };